import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Game } from '../models/game.model';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
//import { resolve } from 'url';
//import { reject } from 'q';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Injectable({
  providedIn: 'root'
})
export class GamesService {

  games: Game[] = [];
  gamesSubject = new Subject<Game[]>();

  constructor(private httpClient: HttpClient) { }

  emitGames() {
    this.gamesSubject.next(this.games);
  }

  saveGames() {
    firebase.database().ref('/games').set(this.games)
  }

  getGames() {
    firebase.database().ref('/games')
      .on('value', (data) => {
        this.games = data.val() ? data.val() : [];
        this.emitGames();
      });
  }

  getSingleGame(game_name: string){
    const gameIndexToView = this.games.findIndex(
      (gameEl) => {
        if (gameEl.title === game_name){
          return true
        }
      }
    )
    return new Promise(
      (resolve,reject) => {
        firebase.database().ref('/games/' + gameIndexToView ).once('value').then(
          (data) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        )
      }
    )
  }

  creatNewGame(newGame: Game) {
    this.games.push(newGame);
    this.saveGames();
    this.emitGames();
  }

  editGames(game_name: string, newGame: Game){
    const gameIndexToView = this.games.findIndex(
      (gameEl) => {
        if (gameEl.title === game_name){
          return true
        }
      }
    )
    this.games[gameIndexToView] = newGame;
    this.saveGames();
    this.emitGames();
  }


  removeGame(game: Game) {
    if(game.photo) {
      const storageRef = firebase.storage().refFromURL(game.photo);
      storageRef.delete().then(
        () => {
          console.log('Photo supprimée !')
        }
      ).catch(
        (error) => {
          console.log('Fichier non trouvé : ' + error)
        }
      )
    }

    const gameIndexToRemove = this.getIndexGame(game);
    this.games.splice(gameIndexToRemove, 1);
    this.saveGames();
    this.emitGames();
  }

  uploadFile(file: File) {
    return new Promise(
      (resolve, reject) => {
        // const almostUniqueFileName = Date.now().toString();
        const upload = firebase.storage().ref()
          .child('images/' + file.name)
          //.child('images/' + almostUniqueFileName + file.name)
          .put(file);

        upload.on(firebase.storage.TaskEvent.STATE_CHANGED,
          () => {console.log('Chargement en cours...')},
          (error) => {
            console.log('Erreur de chargement : ' + error);
            console.log(error.message);
            reject();
          },
          () => {resolve(upload.snapshot.ref.getDownloadURL())} 
        )
      }
    )
  }




  getIndexGame(game: Game){
    const gameIndex = this.games.findIndex(
      (gameEl) => {
        if(gameEl === game) {
            return true;
        }
      }
    );
    return gameIndex
  }
}
